import { colorMatchToPublishType } from "@/utils/color.util";
import { Tag } from "antd";
import React from "react";

interface IProps {
  arr: string[];
}

const PublishType: React.FC<IProps> = ({ arr = [] }) => {
  const arrList = arr.map((e) => e.toLocaleLowerCase());
  const meta = arrList.some((e) => e.includes("meta"));
  const trial = arrList.some((e) => e.includes("trial"));
  const guideline = arrList.some((e) => e.includes("guide"));
  const multi = arrList.some((e) => e.includes("multi"));
  const random = arrList.some((e) => e.includes("random"));
  const edt = arrList.some((e) => e.includes("editorial"));
  const letter = arrList.some((e) => e.includes("letter"));
  const review = arrList.some((e) => e.includes("review"));
  const clinical = arrList.some((e) => e.includes("clinical"));
  const caseReports = arrList.some((e) => e.includes("case"));
  if (meta)
    return <Tag color={colorMatchToPublishType("meta")}>Meta Analysis</Tag>;
  if (guideline)
    return <Tag color={colorMatchToPublishType("guideline")}>Guideline</Tag>;
  if (review)
    return <Tag color={colorMatchToPublishType("review")}>Review</Tag>;
  if (multi)
    return (
      <Tag color={colorMatchToPublishType("multi")}>Multi Center Study</Tag>
    );
  if (random) return <Tag color={colorMatchToPublishType("random")}>RCT</Tag>;
  if (trial) return <Tag color={colorMatchToPublishType("trial")}>Trial</Tag>;
  if (caseReports)
    return (
      <Tag color={colorMatchToPublishType("caseReports")}>Case Report</Tag>
    );
  if (clinical)
    return (
      <Tag color={colorMatchToPublishType("clinical")}>Clinical Study</Tag>
    );
  if (edt) return <Tag color={colorMatchToPublishType("edt")}>Editorial</Tag>;
  if (letter)
    return <Tag color={colorMatchToPublishType("letter")}>Letter</Tag>;
  return (
    <Tag color={colorMatchToPublishType("default")}>{arr[arr.length - 1]}</Tag>
  );
};

export default PublishType;
